import React, { useState, useEffect } from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./PaymentForm";

const StripeContainer = ({ onPaymentSuccess, isLoading, guestEmail }) => {
  const [stripePromise, setStripePromise] = useState(null);
  const [stripeError, setStripeError] = useState(null);

  useEffect(() => {
    const initializeStripe = async () => {
      try {
        const publicKey = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

        if (!publicKey) {
          throw new Error("Publik Stripe-nyckel saknas.");
        }

        const stripeInstance = await loadStripe(publicKey);
        if (!stripeInstance) {
          throw new Error("Det gick inte att initiera Stripe.");
        }

        setStripePromise(stripeInstance);
      } catch (error) {
        setStripeError(error.message || "Det gick inte att ladda betalningssystemet.");
      }
    };

    initializeStripe();
  }, []);

  const options = {
    locale: 'sv'
  };

  if (stripeError) {
    return (
      <div className="stripe-error-container">
        <p>Det gick inte att ladda betalningssystemet. Vänligen försök igen senare.</p>
        <p className="error-details">{stripeError}</p>
      </div>
    );
  }

  if (!stripePromise) {
    return <div className="stripe-loading">Laddar betalningssystemet...</div>;
  }

  return (
    <div className="stripe-container">
      <Elements stripe={stripePromise} options={options}>
        <PaymentForm onPaymentSuccess={onPaymentSuccess} isLoading={isLoading} guestEmail={guestEmail} />
      </Elements>
    </div>
  );
};

export default StripeContainer;